module.exports = __webpack_public_path__ + "img/diginext.f02a7a0.png";